import { getCountriesWithDeliveryEstimations, getGeo } from "@lib/tangem.ts";
import { regionId } from "@components/WalletForm/models/products";

export async function findRegion() {
  const [geo, countries] = await Promise.all([
    getGeo(),
    getCountriesWithDeliveryEstimations(),
  ]);

  if (geo?.code && countries.length > 0) {
    const country = countries.find((country) => country.code === geo.code);
    if (country) {
      regionId.value = country.regionId
    }
  }
}
